import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  icon: string;
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreText?: string;
}

export default function SectionHeading({ icon, title, subtitle, moreTo, moreText }: SectionHeadingProps) {
  return (
    <div className="mb-6 flex items-end justify-between gap-4">
      <div>
        <h2 className="flex items-center gap-2 font-heading text-xl font-black text-foreground-950 md:text-2xl">
          <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className={`${icon} text-lg`}></i>
          </span>
          {title}
        </h2>
        {subtitle && <p className="mt-1.5 text-sm text-foreground-500">{subtitle}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="flex shrink-0 items-center gap-1 whitespace-nowrap text-sm font-medium text-foreground-600 transition-colors hover:text-primary-600 cursor-pointer"
        >
          {moreText || '查看更多'}
          <i className="ri-arrow-right-s-line text-lg"></i>
        </Link>
      )}
    </div>
  );
}